import React from 'react';
import { Popover, PopoverTrigger } from '../../../CommonComponents/OPL/Popover/Popover';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { Badge } from '../../../CommonComponents/OPL/Badge/Badge';
import {
  UserActivityFilterOptionsDTO,
  UserActivitySortFilterApply,
  UserActivitySortOrder,
} from '../../UserActivity.meta';
import { SortFilterContent } from './components/SortFilterContent';

export interface SortFilterProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  filterOptions: UserActivityFilterOptionsDTO;
  sortOrder: UserActivitySortOrder;
  selectedActivityFilterIds: string[];
  selectedUserFilterIds: string[];
  isDataFiltered: boolean;
  onApplyChange: (change: UserActivitySortFilterApply) => void;
}

export const SortFilter = (props: SortFilterProps) => {
  const { isOpen, onOpenChange, isDataFiltered } = props;

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger>
        <Box position="relative">
          <Button
            leftIcon="far fa-filter"
            variant="secondary"
            rightIcon={isOpen ? 'far fa-angle-up' : 'far fa-angle-down'}
          >
            Sort & Filter
          </Button>
          {isDataFiltered && (
            <Box
              position="absolute"
              css={({ theme }) => ({
                top: `${theme.space['16']}px`,
                right: `-${theme.space['8']}px`,
              })}
            >
              <Badge variant="primary" size="small">
                <Icon className="far fa-filter" fontSize="extraSmall" />
              </Badge>
            </Box>
          )}
        </Box>
      </PopoverTrigger>

      {isOpen && <SortFilterContent {...props} />}
    </Popover>
  );
};
